import { create } from "zustand";
import { fetchAppointments as fetchAppointmentsRequest } from "../services/AppointmentService";

// Not persisted: payload contains customer contact info.
const useAppointmentStore = create((set, get) => ({
    month: "",
    appointments: [],
    loading: false,
    error: "",
    setAppointments: (appointments) => set({ appointments }),
    fetchAppointments: async (userID, month) => {
        set({ month, loading: true, error: "" });
        try {
            const payload = await fetchAppointmentsRequest(userID, month);
            // Drop stale responses if the month changed mid-request.
            if (get().month !== month) return;
            set({
                appointments: Array.isArray(payload?.appointments) ? payload.appointments : [],
                loading: false,
            });
        } catch (error) {
            if (get().month !== month) return;
            set({ appointments: [], loading: false, error: error.message });
        }
    },
    clearAppointments: () => set({ month: "", appointments: [], loading: false, error: "" }),
}));

export default useAppointmentStore;